import React from 'react';
import PropTypes from 'prop-types';

const PageNumbers = ({ currentPage, setCurrentPage, pageTotal }) => {
  const numberElements = [];
  const pushToArr = num =>
    numberElements.push(
      <button
        key={num}
        className={num + 1 === currentPage ? 'page-num current' : 'page-num'}
        onClick={() => setCurrentPage(num + 1)}
      >
        {num + 1}
      </button>,
    );

  for (let i = 0; i < pageTotal; i++) {
    // First / last page or page diff is less than 6
    if (i === 0 || i === pageTotal - 1 || Math.abs(i + 1 - currentPage) < 6) {
      pushToArr(i);
      continue;
    }
    // If page difference is equal to 6 return a filler ... component
    if (Math.abs(i + 1 - currentPage) === 6)
      numberElements.push(
        <button key={i} className={'filler'}>
          ...
        </button>,
      );
  }

  return numberElements;
};

PageNumbers.propTypes = {
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  pageTotal: PropTypes.number,
};

export default PageNumbers;
